
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

// bugsnag - front end - just add an api key

// import bugsnag from '@bugsnag/js'
// import bugsnagVue from '@bugsnag/plugin-vue'

// const bugsnagClient = bugsnag({
//   notifyReleaseStages: ['production', 'staging'],
// apiKey: process.env.MIX_BUGSNAG_API_KEY,
//   releaseStage: process.env.NODE_ENV,
// });


// bugsnagClient.use(bugsnagVue, Vue);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

import VueCarousel from 'vue-carousel';

Vue.use(VueCarousel);


const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))



const app = new Vue({
  el: '#app',
  delimiters: ['${', '}'],
  data: {
    mobilenavopen: false,
  },
  created() {
    document.addEventListener('click', this.documentClick);
  },
  destroyed() {
    document.removeEventListener('click', this.documentClick)
  },
});
